// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import type { UploadProps, UploadFile } from "antd";
import { FormInstance } from "antd/es/form";
import { getCsrfToken } from "@/shared/utils/utils";
import { ScaleInput } from "@/components/common/scale-form";

// Define prop types for the FileUpload component
interface FileUploadProps {
    className?: string;
    label: string;
    name: string;
    form: FormInstance;
    accept?:string;
    dark: boolean; // Add this prop
    onSuccess?: (response: UploadedFileResponse) => void;
}

// Define the structure of the server response after file upload
interface UploadedFileResponse {
    id: string;
    originalFileName: string;
    relativePath: string;
    extension: string;
}

const FileUpload: React.FC<FileUploadProps> = ({ label, className, name, form, accept, dark, onSuccess }) => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [csrfToken, setCsrfToken] = useState("");

    // Fetch CSRF token on component mount
    useEffect(() => {
        setCsrfToken(getCsrfToken());
    }, []);

    const uploadProps: UploadProps = {
        name: 'file',
        action: '/api/files/upload',
        headers: {
            'X-CSRF-TOKEN': csrfToken,
        },
        accept: accept,
        maxCount: 1,
        fileList: fileList,
        onChange: (info) => {
            setFileList(info.fileList);
            
            if (info.file.status === 'done') {
                const response: UploadedFileResponse = info.file.response;
                if (response) {
                    const values = {
                        [name]: response.originalFileName,
                        [`${name}_id`]: response.id,
                    };
                    console.log("File uploaded:", values);
                    form.setFieldsValue(values);
                    message.success(`${info.file.name} file uploaded successfully`);
                    
                    if (onSuccess) {
                        onSuccess(response);
                    }
                }
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        beforeUpload: (file) => {
            // Optional: Add file validation here
            return true;
        },
    };

    return (
        <div className={`flex items-center ${dark ? 'dark-mode' : ''}`}>
            <label className={`w-1/3 pr-4 text-right ${dark ? 'text-white' : ''}`} htmlFor={name}>
                {label}
            </label>
            <div className="w-2/3">
                <Upload {...uploadProps}>
                    <Button 
                        icon={<UploadOutlined />}
                        className={`${className} ${dark ? 'dark-mode-upload' : ''}`}
                    >
                        Click to Upload
                    </Button>
                </Upload>
                <ScaleInput
                    readOnly
                    hidden
                    rules={[{ required: true }]}
                    key={name}
                    name={name}
                    label={label}
                    dark={dark} // Pass dark to ScaleInput
                />
                <ScaleInput
                    hidden
                    readOnly
                    key={`${name}_id`}
                    name={`${name}_id`}
                    label={`${label}_id`}
                    rules={[
                        {
                            required: true,
                            message: "File Id is required",
                        },
                    ]}
                    dark={dark} // Pass dark to ScaleInput
                />
            </div>
        </div>
    );
};

export default FileUpload;